import ImageDisplay from '../../../components/ImageDisplay';

/**
 * MessageImageGrid: Displays images in a message with dynamic layout
 * 
 * - 1 image: Fixed width 256px, square aspect ratio
 * - 2+ images: 2-column grid, each 120px width, square aspect ratio
 * - Supports preview URLs (for uploading) and JSONB objects (for uploaded)
 * - Click handler opens image viewer
 * - Fixed aspect ratio prevents layout shift when images load
 */
function MessageImageGrid({ images, currentUserId, senderId, onImageClick }) {
  if (!images || images.length === 0) {
    return null;
  }

  const gridClass = images.length === 1 
    ? 'flex' 
    : 'grid grid-cols-2 gap-1';

  const containerStyle = images.length === 1 
    ? { width: '200px', aspectRatio: '1/1' }
    : { width: '200px' }; // 2 * 96px + 2 * 4px gap

  const imageStyle = images.length === 1
    ? { width: '200px', aspectRatio: '1/1' }
    : { width: '96px', aspectRatio: '1/1' };

  return (
    <div className={gridClass} style={containerStyle}>
      {images.map((image, idx) => {
        // If image has preview (for uploading messages), use ImageDisplay with loading state
        if (image.preview) {
          return (
            <div 
              key={idx} 
              className="rounded-lg overflow-hidden bg-muted cursor-pointer"
              style={imageStyle}
              onClick={() => onImageClick(images, idx)}
            >
              <ImageDisplay 
                imageData={{
                  previewUrl: image.preview,
                  loading: image.loading !== false, // Show loading spinner if loading is true or undefined
                }}
                className="h-full w-full" 
                showLoading={true}
              />
            </div>
          );
        }
        
        // For JSONB objects (from database), use ImageDisplay
        return (
          <div 
            key={idx} 
            className="rounded-lg overflow-hidden bg-muted cursor-pointer"
            style={imageStyle}
            onClick={() => onImageClick(images, idx)}
          >
            <ImageDisplay 
              imageData={image} 
              className="h-full w-full" 
              showLoading={true}
            />
          </div>
        );
      })}
    </div>
  );
}

export default MessageImageGrid;
